<script>
import ResourceService from '@/services/resources/chemical_costs_service';
import SiteView from './SiteView.vue';

export default {
  extends: SiteView,
  components: {
    ActionBar: () => import('@/components/action_bars/ChemicalCostsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-bottle-tonic',
      urlFragment: 'chemicals',
      headers: [
        { text: 'Name', value: 'chemical.name' },
        { text: 'Cost', value: 'cost', align: 'end' },
        { text: 'Expected Daily Usage', value: 'expectedDailyUsage', align: 'end' },
      ],
      sortBy: ['chemical.name'],
    };
  },
  computed: {
    resourceParams() {
      return {
        include: 'chemical',
        filter: {
          site: this.siteId,
        },
      };
    },
  },
};
</script>
